import { generatePath } from "react-router"
import { formatAsRelativeDateTime } from "web/services/format"
import loadingGif from "web/icons/loading.svg"

export default function ImportsList({ kind = undefined, imports, showUrl }) {
  return (
    <div>
      <h3 className="mt-5 text-lg font-bold">Previous Imports</h3>
      <div className="mt-4 flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg">
              <table className="min-w-full table-fixed divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="w-1/2 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500"
                    >
                      File
                    </th>
                    <th
                      scope="col"
                      className="w-1/4 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500"
                    >
                      Uploaded
                    </th>
                    <th
                      scope="col"
                      className="w-1/4 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500"
                    >
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {imports.length === 0 && (
                    <tr>
                      <td className="whitespace-nowrap px-6 py-4" colSpan="3">
                        <div className="text-center text-sm text-gray-500">
                          {kind
                            ? `You have no previous ${kind} imports.`
                            : "You have no previous imports."}
                        </div>
                      </td>
                    </tr>
                  )}
                  {imports.map((importObj) => (
                    <tr key={importObj.id}>
                      <td className="whitespace-nowrap px-6 py-4">
                        <div className="flex items-center">
                          <div className="text-sm font-medium text-primary-4 hover:text-feature-6">
                            <a
                              href={generatePath(showUrl, { id: importObj.id })}
                              data-turbo-action="advance"
                            >
                              {importObj.filename}
                            </a>
                          </div>
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-6 py-4">
                        <div className="text-sm text-gray-900">
                          {formatAsRelativeDateTime(importObj.uploaded_at)}
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-6 py-4">
                        <div className="text-sm capitalize text-gray-900">
                          {importObj.doing_work ? (
                            <img
                              className="ml-4 h-4 w-4"
                              src={loadingGif}
                              alt="loading"
                              draggable="false"
                            />
                          ) : (
                            importObj.display_status
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
